import React, { useState } from "react";
import client, { apiErr } from "../../lib/api";
import { toast } from "sonner";
import { ChevronDown, AlertTriangle, Save } from "lucide-react";
import { ZoneBadge, ScoreBars } from "./shared";

function Row({ r, onSaved }) {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState(r.admin_note || "");
  const m = r.metrics || {};
  const save = async () => {
    try { await client.patch(`/workforce/scores/${r.id}`, { admin_note: note }); toast.success("Review saved — partner ko dikhega"); onSaved(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <div className="surface" data-testid={`wf-row-${r.partner_id}`}>
      <button onClick={() => setOpen(!open)} className="w-full p-4 flex items-center gap-3 text-left" data-testid={`wf-row-toggle-${r.partner_id}`}>
        <div className="font-mono text-2xl text-white w-12">{r.score ?? "—"}</div>
        <div className="min-w-0 flex-1">
          <div className="text-white font-semibold truncate flex items-center gap-1.5"><span className={`w-1.5 h-1.5 rounded-full shrink-0 ${r.on_duty ? "bg-[#22c55e]" : "bg-slate-600"}`} title={r.on_duty ? "On duty" : "Off duty"} />{r.name}{m.red_flags > 0 && <span className="text-[11px] text-bear">🚩{m.red_flags}</span>}</div>
          <div className="text-[11px] text-slate-500 truncate">
            {m.assigned_7d ?? 0} leads (7d) · {m.overdue ?? 0} overdue · {m.unpicked ?? 0} unpicked · {m.converted ?? 0} converted
            {r.leads_paused && <span className="text-bear"> · paused</span>}
          </div>
        </div>
        <ZoneBadge zone={r.zone} testid={`wf-zone-${r.partner_id}`} />
        <ChevronDown size={16} className={`text-slate-500 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-4 pb-4 grid md:grid-cols-2 gap-4 border-t border-[color:var(--border-subtle)] pt-4">
          <div className="space-y-3">
            <ScoreBars parts={m.parts} />
            <div className="text-[11px] text-slate-500">Avg pick: {m.avg_pick_min ?? "—"} min · Share: {r.lead_share ?? "auto"}% · Red streak: {r.red_streak || 0} din</div>
            {r.issues?.length > 0 && (
              <ul className="space-y-1" data-testid={`wf-issues-${r.partner_id}`}>
                {r.issues.map((i) => <li key={i} className="text-xs text-slate-300 flex gap-1.5"><AlertTriangle size={13} className="text-bear shrink-0 mt-0.5" />{i}</li>)}
              </ul>
            )}
          </div>
          <div className="space-y-2">
            {r.ai_tips && <div className="text-xs text-slate-300 whitespace-pre-line bg-white/[0.03] p-3"><div className="text-[10px] uppercase tracking-widest text-gold mb-1">AI suggestion</div>{r.ai_tips}</div>}
            <textarea value={note} onChange={(e) => setNote(e.target.value)} maxLength={600} placeholder="Aapka review / suggestion (partner dashboard aur morning msg me jayega)"
              className="w-full min-h-[80px] bg-[color:var(--app-bg)] border border-[color:var(--border-subtle)] px-3 py-2 text-sm text-white focus:border-gold focus:outline-none" data-testid={`wf-note-${r.partner_id}`} />
            <button onClick={save} className="btn-gold px-3 py-2 text-xs flex items-center gap-1" data-testid={`wf-note-save-${r.partner_id}`}><Save size={13} />Save review</button>
          </div>
        </div>
      )}
    </div>
  );
}

export function ScoresTab({ data, reload }) {
  if (!data.date) return <div className="surface p-8 text-center text-sm text-slate-400" data-testid="wf-empty">Abhi koi score nahi. Har raat 9:30 baje score banta hai — ya upar "Score now" dabayein.</div>;
  return (
    <div className="space-y-4">
      {data.review?.text && (
        <div className="surface p-4 border-l-2 border-gold" data-testid="wf-ai-review">
          <div className="text-[10px] uppercase tracking-widest text-gold mb-2">AI team review · {data.date}</div>
          <div className="text-sm text-slate-300 whitespace-pre-line">{data.review.text}</div>
        </div>
      )}
      <div className="space-y-2">{data.rows.map((r) => <Row key={r.id} r={r} onSaved={reload} />)}</div>
    </div>
  );
}
